import "../src/assets/styles/css/tailwind.css";
import "../src/assets/styles/sass/main.scss";
import "../src/assets/styles/sass/mixin.scss";

export default {
  install() {},
};
